import { IPredefinedTheme } from "../../Themes";
import img1 from "./screenshot.png";

export const Theme: IPredefinedTheme = {
  name: "Light",
  description: "Cobbled Together Light Theme",
  credit: "matt",
  reference: "https://discord.com/channels/415207508303544321/921991895230611466/926114005456658432",
  screenshot: img1,
  colors: {
    primarylight: "#535353",
    primary: "#1A1A1A",
    primarydark: "#0d0d0d",
    successlight: "#63c439",
    success: "#428226",
    successdark: "#2E5A1B",
    errorlight: "#df7051",
    error: "#C94824",
    errordark: "#91341B",
    secondarylight: "#b3b3b3",
    secondary: "#9B9B9B",
    secondarydark: "#7A7979",
    warninglight: "#e8d464",
    warning: "#C6AD20",
    warningdark: "#9F8A16",
    infolight: "#6299cf",
    info: "#3778B7",
    infodark: "#30689C",
    welllight: "#f9f9f9",
    well: "#eaeaea",
    white: "#F7F7F7",
    black: "#000000",
    hp: "#BF5C41",
    money: "#E1B121",
    hack: "#47BC38",
    combat: "#656262",
    cha: "#A568AC",
    int: "#889BCF",
    rep: "#656262",
    disabled: "#70B4BF",
    backgroundprimary: "#F7F7F7",
    backgroundsecondary: "#f9f9f9",
    button: "#eaeaea",
    maplocation: "#000000",
    bnlvl0: "#D33425",
    bnlvl1: "#B8B800",
    bnlvl2: "#38B384",
    bnlvl3: "#374BFF",
  },
};
